module.exports = __webpack_public_path__ + "static/media/rotate-point.82c12041.gif";